/**
 * Interactive Hero
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: '.interactive-hero',

    state: {},

    ima: false,
    images: false,

	events: {
		'input .interactive-hero__content-area__controls__range-slider': 'onRangeSliderValueChange',
		'change .interactive-hero__content-area__controls__range-slider': 'onRangeSliderValueChangeIE',
	},

	initialize() {
        window.addEventListener('resize', this.onResize.bind(this));
        // is it images?
        this.ima = this.el.classList.contains('image-area');
        this.images = this.el.querySelectorAll('img.interactive-hero__video-area__video-main');
	},

    onRender() {
        if (this.ima) {
            this.setState();
            this.configureRangeSlider();
            //hide controls if it's only one image
            if (this.images.length === 1) {
                this.el.querySelector(".interactive-hero__content-area__titles").style.width = 'auto';
                this.el.querySelector(".interactive-hero__content-area.content-area-mobile ").style.display = 'none';
                this.el.querySelector(".interactive-hero__content-area__controls").style.display = 'none';
            }
        } else {
            const vid = this.el.querySelector('.interactive-hero__video-area__video-main');
            vid.onloadeddata = () => {
                this.setState();
                this.configureRangeSlider();
                vid.currentTime = parseInt(this.state.rangeSlider.min);
            };

            vid.ontimeupdate = () => {
                if (vid.currentTime >= this.state.pausePlayingAt) {
                    vid.pause();
                }
            };
        }
	},

	getSlider() {
		const sliders = this.el.querySelectorAll('.interactive-hero__content-area__controls__range-slider');
		return (window.innerWidth <= 1199) ? sliders[1] : sliders[0];
	},

	setState() {
		this.state = {
			rangeSlider: this.getSlider(),
			videoMain: {
				element: this.el.querySelector('.interactive-hero__video-area__video-main'),
				duration: this.el.querySelector('.interactive-hero__video-area__video-main').duration,
				pulseElement: this.el.querySelector('.interactive-hero__video-area__pulse'),
			},
            steps: this.ima ? this.images.length : 3,
            pausePlayingAt: 0,
		};
	},

    configureRangeSlider() {
        if (this.ima) {
            this.state.rangeSlider.max = this.images.length - 1;
            this.state.rangeSlider.step = 1;
            this.state.rangeSlider.min = 0;
        } else {
            this.state.rangeSlider.max = this.state.videoMain.duration.toFixed(2);
            this.state.rangeSlider.step = Math.floor((this.state.videoMain.duration / 3) * 100) / 100;
            this.state.rangeSlider.min = this.state.rangeSlider.step;
        }
		this.state.rangeSlider.value = this.state.rangeSlider.min;
		this.state.rangeSlider.disabled = false;
	},

	onRangeSliderValueChange() {
		this.handleRangeSliderValueChange();
	},

	onRangeSliderValueChangeIE() {
		const ua = navigator.userAgent;
		if (ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1) {
			this.handleRangeSliderValueChange();
		}
	},
	handleRangeSliderValueChange() {
        const value = parseInt(this.state.rangeSlider.value);

        if (this.ima) {
            for (let i = 0; i < this.images.length; i++) {
                this.images[i].style.opacity = (i == value) ? 1 : 0;
            }
        } else {
            if (value >= this.state.pausePlayingAt) {
                this.state.pausePlayingAt = value;
                this.state.videoMain.pulseElement.style.display = 'none';
                this.state.videoMain.element.play();
            } else {
                this.state.pausePlayingAt = value;
                this.state.videoMain.element.currentTime = value;
            }
        }

		if (this.el.dataset.jsGtmData) {
			const { event, eventaction, eventcategory, eventlabel } = JSON.parse(this.el.dataset.jsGtmData);

			dataLayer.push({
				event,
				eventaction,
				eventcategory,
				eventlabel,
			});
		}
	},

	onResize() {
		const vid = this.el.querySelector('.interactive-hero__video-area__video-main');
		this.setState();
		this.configureRangeSlider();
		if(!this.ima) vid.currentTime = parseInt(this.state.rangeSlider.min);
	},
});

export default View;
